import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => {
  const {
    spacing: { unit },
    palette: {
      text,
      common: { white },
    },
  } = theme;

  return createStyles({
    root: {
      backgroundColor: white,
      paddingLeft: unit * 2,
      paddingRight: unit * 2,
      marginBottom: unit * 2,
    },
    cardWrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr auto auto auto auto',
      padding: `${unit}px 0px`,
      alignItems: 'center',
      '&:last-child': {
        paddingBottom: unit,
      },
    },
    title: {
      fontSize: '14px',
      flex: 1,
      fontWeight: 600,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: 'fit-content',
      cursor: 'pointer',
    },
    status: {
      pointerEvents: 'none',
    },
    description: {
      color: text.secondary,
      fontSize: '14px',
      marginRight: unit * 4,
      fontWeight: 500,
    },
    marginRight: {
      marginRight: `${unit}px`,
    },
    chip: {
      boxShadow: 'none',
      borderRadius: 4,
      paddingTop: unit / 2,
      paddingBottom: unit / 2,
      marginRight: unit,
      minWidth: 148,
    },
    descriptionWrapper: {
      display: 'flex',
      gap: `${unit * 2}px`,
      alignItems: 'center',
      marginLeft: `${unit}px`,
    },
  });
};
